import React from "react";

import InfoMessages from "../../../components/infoMessages";
import AppNavBar from "../../../components/navigation";

import { AppWrapper, ContentWrapper, PageWrapper, JumptoLink } from "./layout.styles";
import { LayoutProps } from "./layout.props";
import { jumpTo } from "../../navigation/services/navigation.service";

export const Layout = (props: LayoutProps) => {
  const Header = props.header ?? React.Fragment;


  return (
    <AppWrapper>
      <InfoMessages />
      <JumptoLink 
        id="main-nav" 
        aria-label="Skip to Content"
        title="Skip to Content"
        onClick={() => {
          jumpTo("main-content");
        }}
      >
        Skip to content
      </JumptoLink>
      <AppNavBar />
      <PageWrapper>
        <JumptoLink id="main-content"
          aria-label="Back to Navigation"
          title="Back to Navigation"
          onClick={() => {
            jumpTo("main-nav");
          }}
        >
          Back to navigation
        </JumptoLink>
        <Header />
        <ContentWrapper>{props.children}</ContentWrapper>
        <JumptoLink id="main-bottom"
          aria-label="Back to Top"
          title="Back to Top"
          onClick={() => {
            jumpTo("main-content");
          }}
        >
          Back to top
        </JumptoLink>
      </PageWrapper>
    </AppWrapper>
  );
};

